/* This example requires Tailwind CSS v2.0+ */
import { Dialog } from "@headlessui/react";
import { AnimatePresence, motion } from "framer-motion";
import { useRef } from "react";
import AssignedByListBox from "../../components/clientServiceSubscriptionTask/updateClientServiceSubscriptionTaskModal/AssignedByListBox";

const DeleteEmployeeModal = ({
    isModalOpen,
    setIsModalOpen,
    onRemoveEmployee,
    employees,
    employeeThatReplaces,
    employeeToDelete,
    setEmployeeToReplace,
}) => {
    const cancelButtonRef = useRef(null);
    const onHandleChangeEmployeeToReplace = (employee) => {
        setEmployeeToReplace(employee);
    };
    const employeeFullName = employeeToDelete?.fullName?.trim();
    const employeeName = employeeToDelete?.name?.trim();
    const employeeFirstLastName = [
        employeeToDelete?.firstName,
        employeeToDelete?.lastName,
    ]
        .filter(Boolean)
        .join(" ")
        .trim();
    const employeeDisplayName =
        employeeFullName || employeeName || employeeFirstLastName || "this employee";

    return (
        <AnimatePresence>
            {isModalOpen && (
                <Dialog
                    initialFocus={cancelButtonRef}
                    static
                    as={motion.div}
                    open={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    className="relative z-50"
                >
                    {/* The backdrop, rendered as a fixed sibling to the panel container */}
                    <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

                    {/* Full-screen scrollable container */}
                    <div className="fixed inset-0 w-screen overflow-y-auto">
                        {/* Container to center the panel */}
                        <div className="flex items-center justify-center min-h-full p-4">
                            <Dialog.Panel className="relative w-full px-4 pt-5 pb-4 overflow-hidden text-left transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:max-w-lg sm:p-6">
                                <div className="text-center">
                                    <div className="flex justify-between w-full">
                                        <Dialog.Title
                                            as="h3"
                                            className="w-full text-lg font-medium leading-6 text-left text-gray-900"
                                        >
                                            Remove Employee
                                        </Dialog.Title>
                                        <button
                                            onClick={() => setIsModalOpen(false)}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="w-5 h-5"
                                                viewBox="0 0 20 20"
                                                fill="currentColor"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                                    clipRule="evenodd"
                                                />
                                            </svg>
                                        </button>
                                    </div>
                                    <div className="flex flex-col items-start justify-start w-full mt-4">
                                        <p className="text-sm text-left text-gray-700">
                                            Are you sure you want to delete{" "}
                                            {employeeDisplayName}?
                                        </p>
                                        <div className="w-full mt-1">
                                            <AssignedByListBox
                                                label={
                                                    "Assign employee to inherit data"
                                                }
                                                employees={employees}
                                                assignedBy={employeeThatReplaces}
                                                onChange={(employee) =>
                                                    onHandleChangeEmployeeToReplace(
                                                        employee,
                                                    )
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                                    <button
                                        type="button"
                                        className="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-teal-500 border border-transparent rounded-md shadow-sm hover:bg-teal-600 focus:outline-none focus:ring-0 sm:col-start-2 sm:text-sm"
                                        onClick={() =>
                                            onRemoveEmployee(
                                                employeeThatReplaces.employeeId,
                                            )
                                        }
                                    >
                                        Remove
                                    </button>
                                    <button
                                        type="button"
                                        className="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-0 sm:mt-0 sm:col-start-1 sm:text-sm"
                                        onClick={() => setIsModalOpen(false)}
                                        ref={cancelButtonRef}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </div>
                    </div>
                </Dialog>
            )}
        </AnimatePresence>
    );
};
export default DeleteEmployeeModal;
